import { useCmsStore } from './store/modules/cms.es6';
import { useFlowStore } from './store/modules/flow.es6';
import { useMainStore } from './store/modules/root.es6';
import { useQuizStore } from './store/modules/quiz.es6';

export default function rootState(pinia) {
	let stores = {};
	stores = useMainStore(pinia);
	stores.cms = useCmsStore(pinia);
	stores.flow = useFlowStore(pinia);
	stores.quiz = useQuizStore(pinia);
	return stores;
}
